import { Guid } from '@ups/xplat/core';

export class Tethering {
  isActive: boolean;
  partIdentifier: string;
  tetheringId: string;
  unitPrice: number;

  constructor() {
    this.isActive = true;
    this.tetheringId = Guid.empty;
  }
}
